import {AccessRights} from "../../../constants";
import {SCOPE_CELL_STATUS} from './ScopeCell'
import {UserTeamAssignmentType} from '../constants'
import {ManagementAssignmentsSelection} from 'constants'

export function isManagerScopesAvailable(accessRights, {isURAEnabled , isBTYEnabled}) {
    return (accessRights.indexOf(AccessRights.GENERATE_MONEY_REPORTS) !== -1 && (isURAEnabled || isBTYEnabled)) ||
           accessRights.indexOf(AccessRights.EDIT_HIERARCHY) !== -1 ||
           accessRights.indexOf(AccessRights.SUBMIT_OTHER_USER_TIME_TRACK) !== -1 ||
           accessRights.indexOf(AccessRights.MANAGE_USERS) !== -1
}

export function isAllManagersScopeAssigned(accessRights) {
    return accessRights.indexOf(AccessRights.MANAGE_USERS) !== -1
}

export function getTeamScopeState(teamAssignmentsData, accessRights, {isURAEnabled , isBTYEnabled}) {
    let status = SCOPE_CELL_STATUS.NOT_ALLOWED
    let disabled = false
    let assignedUsersCount = 0

    if (!isManagerScopesAvailable(accessRights, {isURAEnabled , isBTYEnabled})) {
        status = SCOPE_CELL_STATUS.NOT_ALLOWED
        disabled = true
    } else if (isAllManagersScopeAssigned(accessRights)) {
        status = SCOPE_CELL_STATUS.ALL
        disabled = true
    } else {
        const assignmentsData = teamAssignmentsData
        assignedUsersCount = assignmentsData.assignedUsersCount

        if (assignmentsData.teamAssignmentType === UserTeamAssignmentType.ALL) {
            status = SCOPE_CELL_STATUS.ALL
        } else if (assignmentsData.teamAssignmentType === UserTeamAssignmentType.NO){
            status = SCOPE_CELL_STATUS.NO_ACCESS
        } else if (assignedUsersCount > 0) {
            status = SCOPE_CELL_STATUS.SELECTED
        } else {
            status = SCOPE_CELL_STATUS.NOT_SELECTED
        }
    }

    return {
        status,
        assignedUsersCount,
        disabled
    }
}

export const isEntireManagementScopeAssigned = (managementAssignmentsSelection, accessRights) => {
    return isAllManagersScopeAssigned(accessRights) || managementAssignmentsSelection === ManagementAssignmentsSelection.ALL
}

export function getManagerScopeState(managementAssignmentsCounts, managementAssignmentsSelection, accessRights, {isURAEnabled , isBTYEnabled}) {
    let status = SCOPE_CELL_STATUS.NOT_ALLOWED
    let disabled = false
    let nCustomers = 0
    let nProjects = 0
    let nTasks = 0
    if (!isManagerScopesAvailable(accessRights, {isURAEnabled , isBTYEnabled})) {
        status = SCOPE_CELL_STATUS.NOT_ALLOWED
        disabled = true
    } else if (isAllManagersScopeAssigned(accessRights)) {
        status = SCOPE_CELL_STATUS.ALL
        disabled = true
    } else {
        nCustomers = managementAssignmentsCounts.customers
        nProjects = managementAssignmentsCounts.projects
        nTasks = managementAssignmentsCounts.tasks

        if (managementAssignmentsSelection === ManagementAssignmentsSelection.ALL) {
            status = SCOPE_CELL_STATUS.ALL
        } else if (managementAssignmentsSelection === ManagementAssignmentsSelection.NO) {
            status = SCOPE_CELL_STATUS.NO_ACCESS
        } else if ((nCustomers + nProjects + nTasks) > 0) {
            status = SCOPE_CELL_STATUS.SELECTED
        } else {
            status = SCOPE_CELL_STATUS.NOT_SELECTED
        }
    }

    return {
        status,
        nCustomers,
        nProjects,
        nTasks,
        disabled,
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/utils.js